import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SettingsService } from '../services/user/settings.service';
import { isFeatureEnabledInUserSettings, getUserActiveProducts } from '../../utils';

/**
 * Guard to check if user has access to Subscriptions functionality
 * This guard checks the user's settings for Subscriptions feature
 */
export const subscriptionsAccessGuard: CanActivateFn = () => {
  const settingsService = inject(SettingsService);
  const router = inject(Router);

  return settingsService.getUserSettings().pipe(
    map(settings => {
      const userActiveProducts = getUserActiveProducts();
      const isEnabled = isFeatureEnabledInUserSettings(settings, 'General_Features', 'Subscriptions', userActiveProducts);
      if (!isEnabled) {
        // Redirect to home page if subscriptions are disabled in user settings
        router.navigate(['/home']);
        return false;
      }
      return true;
    })
  );
};
